/**
 * Paleta de cores do Sistema MEDICARE
 */

export const colors = {
  // Cores primárias do MEDICARE
  medicare: {
    50: '#e6f3ff',
    100: '#b3d9ff',
    200: '#80bfff',
    300: '#4da6ff',
    400: '#1a8cff',
    500: '#0066cc', // Cor principal
    600: '#0052a3',
    700: '#003d7a',
    800: '#002952',
    900: '#001429',
  },
  
  // Cores secundárias (verde médico)
  medical: {
    50: '#f0fff4',
    100: '#c6f6d5',
    200: '#9ae6b4',
    300: '#68d391',
    400: '#48bb78',
    500: '#38a169', // Verde médico
    600: '#2f855a',
    700: '#276749',
    800: '#22543d',
    900: '#1a202c',
  },
  
  // Cores de status
  status: {
    // Sucesso
    success: {
      50: '#f0fff4',
      100: '#c6f6d5',
      200: '#9ae6b4',
      300: '#68d391',
      400: '#48bb78',
      500: '#38a169',
      600: '#2f855a',
      700: '#276749',
      800: '#22543d',
      900: '#1a202c',
    },
    // Aviso
    warning: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde68a',
      300: '#fcd34d',
      400: '#fbbf24',
      500: '#f59e0b',
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f',
    },
    // Erro
    error: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#ef4444',
      600: '#dc2626',
      700: '#b91c1c',
      800: '#991b1b',
      900: '#7f1d1d',
    },
    // Informação
    info: {
      50: '#eff6ff',
      100: '#dbeafe',
      200: '#bfdbfe',
      300: '#93c5fd',
      400: '#60a5fa',
      500: '#3b82f6',
      600: '#2563eb',
      700: '#1d4ed8',
      800: '#1e40af',
      900: '#1e3a8a',
    },
  },
  
  // Cores neutras customizadas
  neutral: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#e5e5e5',
    300: '#d4d4d4',
    400: '#a3a3a3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
  },
  
  // Cores específicas para tipos de usuário
  userTypes: {
    admin: {
      50: '#fdf4ff',
      100: '#fae8ff',
      200: '#f5d0fe',
      300: '#f0abfc',
      400: '#e879f9',
      500: '#d946ef',
      600: '#c026d3',
      700: '#a21caf',
      800: '#86198f',
      900: '#701a75',
    },
    medico: {
      50: '#eff6ff',
      100: '#dbeafe',
      200: '#bfdbfe',
      300: '#93c5fd',
      400: '#60a5fa',
      500: '#3b82f6',
      600: '#2563eb',
      700: '#1d4ed8',
      800: '#1e40af',
      900: '#1e3a8a',
    },
    enfermeiro: {
      50: '#f0fdf4',
      100: '#dcfce7',
      200: '#bbf7d0',
      300: '#86efac',
      400: '#4ade80',
      500: '#22c55e',
      600: '#16a34a',
      700: '#15803d',
      800: '#166534',
      900: '#14532d',
    },
    paciente: {
      50: '#fefce8',
      100: '#fef9c3',
      200: '#fef08a',
      300: '#fde047',
      400: '#facc15',
      500: '#eab308',
      600: '#ca8a04',
      700: '#a16207',
      800: '#854d0e',
      900: '#713f12',
    },
  },
  
  // Cores para status de consulta
  consultaStatus: {
    agendada: {
      bg: '#dbeafe',
      color: '#1e40af',
      border: '#3b82f6',
    },
    em_andamento: {
      bg: '#fef3c7',
      color: '#92400e',
      border: '#f59e0b',
    },
    concluida: {
      bg: '#d1fae5',
      color: '#065f46',
      border: '#10b981',
    },
    cancelada: {
      bg: '#fee2e2',
      color: '#991b1b',
      border: '#ef4444',
    },
  },
  
  // Cores para prioridades
  priority: {
    baixa: {
      bg: '#f0fdf4',
      color: '#166534',
      border: '#22c55e',
    },
    media: {
      bg: '#fffbeb',
      color: '#92400e',
      border: '#f59e0b',
    },
    alta: {
      bg: '#fef2f2',
      color: '#991b1b',
      border: '#ef4444',
    },
    urgente: {
      bg: '#fdf2f8',
      color: '#86198f',
      border: '#d946ef',
    },
  },
  
  // Gradientes
  gradients: {
    primary: 'linear(to-r, medicare.500, medicare.600)',
    secondary: 'linear(to-r, medical.500, medical.600)',
    success: 'linear(to-r, status.success.500, status.success.600)',
    warning: 'linear(to-r, status.warning.500, status.warning.600)',
    error: 'linear(to-r, status.error.500, status.error.600)',
    info: 'linear(to-r, status.info.500, status.info.600)',
    sunset: 'linear(to-r, #ff7e5f, #feb47b)',
    ocean: 'linear(to-r, #667eea, #764ba2)',
    forest: 'linear(to-r, #134e5e, #71b280)',
  },
};